import _extends from "@babel/runtime/helpers/esm/extends";
import classNames from 'classnames';
import CSSMotion from '../../../motion';
import useLayoutEffect from '../../../utils/useLayoutEffect';
import * as React from 'react';
import Arrow from './Arrow';
import PopupContent from './PopupContent';
function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (typeof ref === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(function (ref) {
    return ref;
  });
  if (refList.length <= 1) {
    return refList[0];
  }
  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
var Popup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var popup = props.popup,
    className = props.className,
    prefixCls = props.prefixCls,
    style = props.style,
    target = props.target,
    _onVisibleChanged = props.onVisibleChanged,
    open = props.open,
    keepDom = props.keepDom,
    onClick = props.onClick,
    arrow = props.arrow,
    align = props.align,
    motion = props.motion,
    forceRender = props.forceRender,
    getPopupContainer = props.getPopupContainer,
    autoDestroy = props.autoDestroy,
    Portal = props.portal,
    zIndex = props.zIndex,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    ready = props.ready,
    offsetX = props.offsetX,
    offsetY = props.offsetY,
    onPrepare = props.onPrepare;
  var childNode = typeof popup === 'function' ? popup() : popup;

  // We can not remove holder only when motion finished.
  var isNodeVisible = open || keepDom;

  // ======================= Container ========================
  var getPopupContainerNeedParams = ((getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) || 0) > 0;
  var _React$useState = React.useState(!getPopupContainer || !getPopupContainerNeedParams),
    show = _React$useState[0],
    setShow = _React$useState[1];

  // Delay to show since `getPopupContainer` need target element
  useLayoutEffect(function () {
    if (!show && getPopupContainerNeedParams && target) {
      setShow(true);
    }
  }, [show, getPopupContainerNeedParams, target]);

  // ========================= Render =========================
  if (!show) {
    return null;
  }

  // >>>>> Offset
  var offsetStyle = ready || !open ? {
    left: offsetX,
    top: offsetY
  } : {
    left: '-1000vw',
    top: '-1000vh'
  };

  // >>>>> Misc
  var miscStyle = {};
  if (!open) {
    miscStyle.pointerEvents = 'none';
  }
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(Portal, {
      open: forceRender || isNodeVisible,
      getContainer: getPopupContainer && function () {
        return getPopupContainer(target);
      },
      autoDestroy: autoDestroy
    }, /*#__PURE__*/React.createElement(CSSMotion, _extends({
      motionAppear: true,
      motionEnter: true,
      motionLeave: true,
      removeOnLeave: false,
      forceRender: forceRender,
      leavedClassName: prefixCls + "-hidden"
    }, motion, {
      onAppearPrepare: onPrepare,
      onEnterPrepare: onPrepare,
      visible: open,
      onVisibleChanged: function onVisibleChanged(nextVisible) {
        var _motion$onVisibleChan;
        motion === null || motion === void 0 ? void 0 : (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 ? void 0 : _motion$onVisibleChan.call(motion, nextVisible);
        _onVisibleChanged(nextVisible);
      }
    }), function (_ref, motionRef) {
      var motionClassName = _ref.className,
        motionStyle = _ref.style;
      var cls = classNames(prefixCls, motionClassName, className);
      return /*#__PURE__*/React.createElement("div", {
        ref: composeRef(ref, motionRef),
        className: cls,
        style: _extends({}, offsetStyle, miscStyle, motionStyle, {
          boxSizing: 'border-box',
          zIndex: zIndex
        }, style),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick
      }, arrow && /*#__PURE__*/React.createElement(Arrow, {
        prefixCls: prefixCls,
        arrow: arrow,
        align: align
      }), /*#__PURE__*/React.createElement(PopupContent, {
        cache: !open
      }, childNode));
    }))
  );
});
if (process.env.NODE_ENV !== 'production') {
  Popup.displayName = 'Popup';
}
export default Popup;